import React from 'react'
import { NotificationProvider } from './context/NotificationContext'
import { useNotificationActions } from './lib/useNotificationActions'
import { Alert } from './components/Alert/Alert'
import { Toast } from './components/Toast/Toast'

export const NotificationRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <NotificationProvider>
    <Alert />
    <Toast />
    {children}
  </NotificationProvider>
)

export { useNotificationActions }